import { render, staticRenderFns } from "./UpdatePrompt.vue?vue&type=template&id=0488c2b4&scoped=true"
import script from "./UpdatePrompt.vue?vue&type=script&lang=js"
export * from "./UpdatePrompt.vue?vue&type=script&lang=js"
import style0 from "./UpdatePrompt.vue?vue&type=style&index=0&id=0488c2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0488c2b4",
  null
  
)

export default component.exports